<div class="rs-leadership">
  <div class="rs-leadership__who-signing">
    <rs-who-signing></rs-who-signing>
  </div>
</div>
